import React from 'react';
import { Divider } from '@material-ui/core';
import Ratings from '../../../components/Ratings/Ratings';
import { isNullOrUndefined } from '../../../utils/utilityFunctions';


const SummaryTile = ({ title, value, comparison, isPercentageValue, }: { title: string; value: number; comparison: number, isPercentageValue: boolean }) => {
    return (
        <div className='summary_tile primary_tile_background '>
            <div className="title_container">
                <h3 className='summary_title'>{title}</h3>
            </div>
            <Divider variant='fullWidth' flexItem />
            <div className='summary_value '>{value?.toLocaleString(undefined, { maximumFractionDigits: 1 })}{isPercentageValue ? "%" : ""}</div>
            <div className="value-container">

                <div className={`value ${comparison ? comparison > 0 ? "text-green" : comparison < 0 ? "text-red" : "" : ""}`}>
                    {isNullOrUndefined(comparison) ? null : <Ratings value={comparison} isPercentageValue={isPercentageValue} />}    {isNullOrUndefined(comparison) ? "n/a" : comparison ? comparison : "n/a"}{comparison && isPercentageValue ? "%" : ""} vs last period
                </div>
            </div>
        </div>
    )
}

export default SummaryTile;